import { render, staticRenderFns } from "./OrderFrequency.vue?vue&type=template&id=090f5bb3&scoped=true"
import script from "./OrderFrequency.vue?vue&type=script&lang=js"
export * from "./OrderFrequency.vue?vue&type=script&lang=js"
import style0 from "./OrderFrequency.vue?vue&type=style&index=0&id=090f5bb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090f5bb3",
  null
  
)

export default component.exports